module.exports = __webpack_public_path__ + "static/media/lake-near-mountains.317d6ec0.jpg";